<template>
  <v-container v-if="isPromotionsEnabled" fluid class="pa-0">

    <app-promo-actions-user-holiday-dlg v-if="isHolidayDlgRendered" :promoAction="userPromoAction">
    </app-promo-actions-user-holiday-dlg>

  </v-container>
</template>

<script>
import get from 'lodash/get';

import { logHelper } from '@/helpers/log-helper';
import { logger } from '@/helpers/log.service';
import uiMixin from '@/mixins/ui-mixin';
import { AppError } from '@/models/log.models';
import { actions as _act } from '@/models/store.actions';
import { promoActionsService } from '@/services/promo-actions.service';

import AppPromoActionsUserHolidayDlg from './AppPromoActionsUserHolidayDlg';
import { PromoActionCode } from '@/models/enums';

export default {
  name: 'AppPromoActionsUser',
  components: { AppPromoActionsUserHolidayDlg },
  mixins: [uiMixin],
  data() {
    return {
      isPromotionsEnabled: false,
      userAvailablePromoActions: [],
      userPromoAction: null
    };
  },
  computed: {
    isHolidayDlgRendered() {
      return (
        !!this.userPromoAction &&
        (this.userPromoAction.code === PromoActionCode.NewYear ||
         this.userPromoAction.code === PromoActionCode.Christmas)
      );
    },
    isLogined() {
      return this.$store.getters[_act.AUTH_GET_ISLOGINEDGET];
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const appSettings = await this.$store.getters[_act.SETT_GET_STG_WAITER];
      const promotionsEnabled = get(
        appSettings,
        'globalSettings.globalSettingItems.promotionsEnabled.settingValue'
      );
      this.isPromotionsEnabled = promotionsEnabled === '1';
      logger.debug(
        `[AppPromoActionsUser] isPromotionsEnabled=${this.isPromotionsEnabled}`
      );
      if (this.isPromotionsEnabled) {
        this.subscribe();
        if (this.isLogined) {
          await this.loadPromoActionsAvailableForUser(true);
        }
      }
    },
    subscribe() {
      this.$eventBus.$on('user-logged', this.onUserLogged);
    },
    unsubscribe() {
      this.$eventBus.$off('user-logged', this.onUserLogged);
    },
    onUserLogged() {
      this.loadPromoActionsAvailableForUser();
    },
    async loadPromoActionsAvailableForUser(ignoreViewed) {
      const loader = this.showLoading();
      try {
        this.userAvailablePromoActions = [];
        this.userPromoAction = null;

        this.userAvailablePromoActions =
          await promoActionsService.getUserPromoActions();
        logger.debug(
          '[AppPromoActionsUser] promoActions',
          this.userAvailablePromoActions
        );
        if (
          this.userAvailablePromoActions.length > 0 &&
          (!ignoreViewed || this.userAvailablePromoActions[0].dateView === null)
        ) {
          this.userPromoAction = this.userAvailablePromoActions[0];
        }
      } catch (err) {
        if (!(err instanceof AppError)) { logHelper.error(err); }
      } finally {
        loader.hide();
      }
    }
  }
};
</script>
